import { render, staticRenderFns } from "./AccountBalancesBlotterView.vue?vue&type=template&id=40505a99&scoped=true&"
import script from "./AccountBalancesBlotterView.vue?vue&type=script&lang=js&"
export * from "./AccountBalancesBlotterView.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalancesBlotterView.vue?vue&type=style&index=0&id=40505a99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40505a99",
  null
  
)

export default component.exports